import { ListUser } from '@platform/client/schemas';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { ProUserFilters } from './ProUserSearchForm';
import { Dispatch, useContext, useMemo } from 'react';
import { AdminTable, AdminTableContext } from '../../AdminTable';
import { ModalCallToAction } from '@platform/components';
import { keepPreviousData } from '@tanstack/react-query';
import { AdminSearch } from '@platform/client';
import { proFiltersToQueryParams } from './utils';

const proUserColumnHelper = createColumnHelper<ListUser>();

export const ProUserResultsTable = (props: {
  filters: ProUserFilters;
  setFilters: Dispatch<React.SetStateAction<ProUserFilters | undefined>>;
  setDownloadModalOpen: Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { filters, setDownloadModalOpen } = props;
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const { data, isLoading, isError, isSuccess } = AdminSearch.useGetProfessionalUsers(
    {
      ...proFiltersToQueryParams(filters),
      page: adminQueryOptionsV2.page,
      limit: adminQueryOptionsV2.limit,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  const { users = [], filteredCount = 0 } = data || {};
  const columns = useMemo(() => {
    return [
      proUserColumnHelper.accessor('id', {
        header: 'ID',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('firstName', {
        header: 'First Name',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('lastName', {
        header: 'Last Name',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('email', {
        header: 'Email',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('corporateClient', {
        header: 'Corporate Client',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('cohort', {
        header: 'Cohort',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('timezone', {
        header: 'Timezone',
        cell: (info) => info.getValue(),
      }),
      proUserColumnHelper.accessor('applicationStatus', {
        header: 'Application Status',
        cell: (info) => info.getValue(),
      }),
    ] as ColumnDef<ListUser>[];
  }, []);

  const tableActions: ModalCallToAction[] = [
    {
      text: 'Modify filters',
      callback: () => {
        props.setFilters(undefined);
      },
    },
  ];
  if (isSuccess && users.length > 0) {
    tableActions.push({
      text: 'Export results',
      callback: () => {
        setDownloadModalOpen(true);
      },
    });
  }

  return (
    <AdminTable
      data={users}
      filteredCount={filteredCount}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      enableSorting={false}
      tableActions={tableActions}
    />
  );
};
